// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.phone > svg {\n  height: 100px;\n  width: 100px;\n}\n.desktopLogo > svg {\n  height: 100px;\n  width: 150px;\n}\n", ""]);
// Exports
module.exports = exports;
